





















































import Vue from 'vue'
import { Component } from 'vue-mixin-decorator'

@Component({})
export default class FullscreenNotificationLayout extends Vue {
}
